import React from "react";
import * as Icon from "react-feather";
import clsx from "clsx";

import ToolsSelect from "./ToolsSelect";

import "./tools-mapping-row.css";

class ToolsMappingRow extends React.Component {
	render() {
		const { isChosen, label, sublabel, amount, options, value, placeholder, searchPlaceholder, disabled, onChange, suggestion, onAcceptSuggestion } = this.props;

		const hasUntakenSuggestion = Boolean(suggestion) && Boolean(suggestion.value) && suggestion.value !== value;

		return (
			<div className="tk-mapping">
				<div className="tk-mapping__line">
					<span className={clsx("tk-mapping__mark", isChosen && "tk-mapping__mark--chosen")}>
						{isChosen ? <Icon.Check size={12} /> : <Icon.Circle size={8} />}
					</span>

					<span className="tk-mapping__label">
						<span className="tk-mapping__label-text">{label}</span>
						{sublabel && <span className="tk-mapping__sublabel tk-text-muted">{sublabel}</span>}
					</span>

					{amount !== undefined && amount !== null && <span className="tk-mapping__amount tk-amount">{amount}</span>}

					<span className="tk-mapping__control">
						<ToolsSelect
							value={value}
							options={options}
							placeholder={placeholder}
							searchable={true}
							searchPlaceholder={searchPlaceholder}
							inline={true}
							disabled={disabled || options.length === 0}
							onChange={onChange}
						/>
					</span>
				</div>

				{hasUntakenSuggestion && (
					<div className="tk-mapping__suggestion">
						<div className="tk-mapping__suggestion-action">
							<button className="tk-text-action" onClick={onAcceptSuggestion} type="button" disabled={disabled}>
								Use {suggestion.label}
							</button>
							{suggestion.isCertain && <span className="tk-badge tk-badge--success">{suggestion.certaintyLabel || "exact match"}</span>}
						</div>
						{suggestion.evidence && <div className="tk-mapping__suggestion-evidence tk-text-muted">{suggestion.evidence}</div>}
					</div>
				)}
			</div>
		);
	}
}

export default ToolsMappingRow;
